import React, { useCallback } from 'react';
import ProgressBarStepperWrapper from '@fingo/lib/components/steppers/progressBarStepper/ProgressBarStepperWrapper';
import AvailableFactoringView from '@fingo/lib/features/factoring/views/AvailableFactoringView';
import getColumns from '../../../../features/factoring/constants/available-factoring';
import FACTORING_TUTORIALS from '../../../../features/factoring/constants/header-tutorials';
import OPTIONS from '../../../../features/factoring/constants/available-factoring-options';
import AvailableFactoringOverlay from '../../../../features/factoring/components/overlays/AvailableFactoringOverlay';
import FactoringSummary from '../../../../features/factoring/components/summaries/FactoringSummary';
import EvaluationSentDialog from '../../../../features/factoring/components/dialogs/EvaluationSentDialog';

const AvailableFactoring = () => {
  const getEvaluationSentDialogProps = useCallback(({
    open,
    onClose,
    warningMessage,
  }) => ({
    open,
    onClose,
    warningMessage,
  }), []);

  return (
    <AvailableFactoringView
      enableCreditLineFlow
      getColumns={getColumns}
      tutorial={FACTORING_TUTORIALS.available_factoring}
      includeHeaders={OPTIONS.includeHeaders}
      mobileHeaders={OPTIONS.mobileHeaders}
      summaryHeaders={OPTIONS.summaryHeaders}
      summaryMobileHeaders={OPTIONS.summaryMobileHeaders}
      initialOrderBy={OPTIONS.initialOrderBy}
      isRowSelectable={OPTIONS.isRowSelectable}
      getRowClassName={OPTIONS.getRowClassName}
      initialInvoiceFilters={OPTIONS.initialInvoiceFilters}
      actionButtonComponent={OPTIONS.actionButtonComponent}
      warningAlertComponent={OPTIONS.warningAlertComponent}
      summaryDataInfo={OPTIONS.summaryDataInfo}
      getWarningParams={OPTIONS.getWarningParams}
      OverlayComponent={AvailableFactoringOverlay}
      SummaryComponent={FactoringSummary}
      EvaluationSentDialogComponent={EvaluationSentDialog}
      StepperComponent={ProgressBarStepperWrapper}
      stepperPlacement="top"
      getStepsConditions={OPTIONS.getStepsConditions}
      headerDescription="Selecciona tus facturas que quieras cotizar"
      useBorderedTitle
      getEvaluationSentDialogProps={getEvaluationSentDialogProps}
    />
  );
};

export default AvailableFactoring;
